module.exports = __webpack_public_path__ + "img/8.aa7ed754.svg";